import { Component } from '@angular/core';
import { intToTime } from '../../../helpers/formatNumbers';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
  selector: 'app-bar-total-duration',
  templateUrl: './bar-total-duration.component.html',
  styleUrl: './bar-total-duration.component.scss',
})
export class BarTotalDurationComponent {
  isLoading = true;

  formatFunction = intToTime;

  constructor(protected analyticsService: AnalyticsService) {
    this.analyticsService.barTotalDuration$.subscribe((data) => {});

    this.analyticsService.isLoading$.subscribe((loading) => {
      this.isLoading = loading.includes('barTotalDuration');
    });

    this.getChartData();
  }

  getChartData() {
    this.analyticsService.getBarTotalDuration().subscribe();
  }

  get data() {
    return this.analyticsService.barTotalDuration$.value;
  }
}
